import type {ForestMassStatusesRepository, filters} from '@/domain/interfaces/ForestMassStatusesRepository';
import type {HttpClient} from '@/infrastructure/interfaces/HttpClient';
import type {ForestMassStatusDto} from './ForestMassStatusDto';
import {toDomain} from './ForestMassStatusMappers';

const BASE_PATH = 'reports/forest-mass-statuses';

export class RestForestMassStatusRepository implements ForestMassStatusesRepository {
  constructor(private readonly httpClient: HttpClient) {}
  getAll = async (filters?: filters) => {
    // Construir los parámetros de consulta a partir de los filtros
    const queryParams = new URLSearchParams();

    if (filters?.forestMassUuid) {
      queryParams.append('forestMassUuid', filters.forestMassUuid);
    }
    if (filters?.finsaStatus) {
      queryParams.append('finsaStatus', filters.finsaStatus);
    }
    if (filters?.aseforStatus) {
      queryParams.append('aseforStatus', filters.aseforStatus);
    }
    if (filters?.fortopStatus) {
      queryParams.append('fortopStatus', filters.fortopStatus);
    }
    if (filters?.bbox) {
      queryParams.append('bbox', filters.bbox.join(','));
    }

    const queryString = queryParams.toString();
    const path = queryString ? `${BASE_PATH}?${queryString}` : `${BASE_PATH}`;

    const dtos = await this.httpClient.get<Array<ForestMassStatusDto>>(path);

    return dtos.map((dto) => toDomain(dto));
  };
}
